import __request__ from "routing/request";
export function grokTest(pattern, string, named_captures_only, requestOptions) {
  return __request__("GET", "/tools/grok_tester", null, { "pattern": pattern, "string": string, "named_captures_only": named_captures_only }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function testGrok(JSONbody, requestOptions) {
  return __request__("POST", "/tools/grok_tester", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
